"use client";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";
const Footer = ({ isModalOpen, setIsModalOpen, modalState, setModalState }) =>  {
  const [footerLinks, setFooterLinks] = useState({});
  const [headerData, setHeaderData] = useState(null);
  const [openSection, setOpenSection] = useState(null);
  const { user } = useContext(AuthContext);
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  useEffect(() => {
    const fetchFooterLinks = async () => {
      try {
        const res = await api.get("/api/footer");
        setFooterLinks(res.data || {});
      } catch (err) {
        console.error("Footer API Error:", err);
      }
    };
    fetchFooterLinks();
  }, []);

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const res = await api.get("/api/homepage-data");
        setHeaderData(res.data);
      } catch (err) {
        console.error("Failed to fetch header data:", err);
      }
    };
    fetchHeaderData();
  }, []);
  
 const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;

    const name = "";
    const email = form.email.value;
    const phone = form.phone.value;

    const emailChecked = form.consent_email.checked;
    const smsChecked = form.consent_sms.checked;

    let channel = "";
    if (emailChecked && smsChecked) channel = "both";
    else if (emailChecked) channel = "email";
    else if (smsChecked) channel = "sms";

    const consent = form.consent_policies.checked ? 1 : 0;

    const formData = {
      name,
      email,
      phone,
      channel,
      consent,
    };

    try {
      const res = await api.post("/api/subscribe", formData);

      if (res.data.success) {
        setModalState("success"); 
        form.reset();  // ← show success block
      }
    } catch (err) {
      console.error(err);
    }
};


  const getUrl = (link, fallback) => (link?.url ? link.url : fallback);
  const getTitle = (link, fallback) => (link?.title ? link.title : fallback);

  return (
    <>
      {/* FOOTER */}
      <footer className="wg-footer" role="contentinfo">
        {/* MOBILE SUBSCRIBE & SAVE BAND */}
        <div className="wg-footer-subscribe">
          <div className="footer-card">
            <div className="icon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
            </div>
            <div className="copy">
              <h3>Subscribe &amp; Save 10% on Your First Order! </h3>
              <p>Automatic discount on every future order.</p>
            </div>
            <button type="button" data-open-subscribe onClick={() => setIsModalOpen(true)}>
              Join
            </button>
          </div>
        </div>

        <div className="inner">
          {/* Customer Service */}
          <div className={`footer-col ${openSection === "customer" ? "open" : ""}`}>
            <h4  className="footer-accordion-title" onClick={() => toggleSection("customer")}>Customer Service</h4>
            <div className={`footer-accordion-content ${openSection === "customer" ? "open" : ""}`}>
              {footerLinks["Contact Us"] && (
                <Link to={getUrl(footerLinks["Contact Us"], "/contact")}>
                  {getTitle(footerLinks["Contact Us"], "Contact Us")}
                </Link>
              )}
              {footerLinks["Price Match Policy"] && (
                <Link to={getUrl(footerLinks["Price Match Policy"], "/price-match-policy")}>
                  {getTitle(footerLinks["Price Match Policy"], "Price Match Policy")}
                </Link>
              )}
              {footerLinks["Return Policy"] && (
                <Link to={getUrl(footerLinks["Return Policy"], "/return-policy")}>
                  {getTitle(footerLinks["Return Policy"], "Return Policy")}
                </Link>
              )}
              {footerLinks["Shipping & Delivery"] && (
                <Link to={getUrl(footerLinks["Shipping & Delivery"], "/shipping-delivery")}>
                  {getTitle(footerLinks["Shipping & Delivery"], "Shipping & Delivery")}
                </Link>
              )}
            </div>
          </div>

          {/* Company Information */}
          <div className={`footer-col ${openSection === "about" ? "open" : ""}`}>
            <h4  className="footer-accordion-title" onClick={() => toggleSection("about")}>Company Information</h4>
            <div className={`footer-accordion-content ${openSection === "about" ? "open" : ""}`}>
              {footerLinks["About Us"] && (
                <Link to={getUrl(footerLinks["About Us"], "/about")}>
                  {getTitle(footerLinks["About Us"], "About Us")}
                </Link>
              )}
              {footerLinks["Privacy Policy"] && (
                <Link to={getUrl(footerLinks["Privacy Policy"], "/privacy")}>
                  {getTitle(footerLinks["Privacy Policy"], "Privacy Policy")}
                </Link>
              )}
              {footerLinks["Recall Notices"] && (
                <Link to={getUrl(footerLinks["Recall Notices"], "/recall-notices")}>
                  {getTitle(footerLinks["Recall Notices"], "Recall Notices")}
                </Link>
              )}
              {footerLinks["Terms & Conditions"] && (
                <Link to={getUrl(footerLinks["Terms & Conditions"], "/terms")}>
                  {getTitle(footerLinks["Terms & Conditions"], "Terms & Conditions")}
                </Link>
              )}
            </div>
          </div>

          {/* Online Resources */}
          <div className={`footer-col ${openSection === "online" ? "open" : ""}`}>
            <h4 className="footer-accordion-title" onClick={() => toggleSection("online")}>Online Resources</h4>
            <div className={`footer-accordion-content ${openSection === "online" ? "open" : ""}`}>
              {footerLinks["FAQs"] && (
                <Link to={getUrl(footerLinks["FAQs"], "/faq")}>
                  {getTitle(footerLinks["FAQs"], "FAQs")}
                </Link>
              )}
              {footerLinks["Sizing"] && (
                <Link to={getUrl(footerLinks["Sizing"], "/sizing")}>
                  {getTitle(footerLinks["Sizing"], "Sizing")}
                </Link>
              )}
              {footerLinks["Custom Imprinting & Embroidery"] && (
                <Link to={getUrl(footerLinks["Custom Imprinting & Embroidery"], "/custom-imprinting")}>
                  {getTitle(footerLinks["Custom Imprinting & Embroidery"], "Custom Imprinting & Embroidery")}
                </Link>
              )}
              {footerLinks["Custom Quote"] && (
                <Link to={getUrl(footerLinks["Custom Quote"], "/custom-quote")}>
                  {getTitle(footerLinks["Custom Quote"], "Custom Quote")}
                </Link>
              )}
            </div>
          </div>

          {/* My Account */}
          <div className="footer-col">
            <h4 className="footer-accordion-title" onClick={() => toggleSection("account")}>My Account</h4>
            <div className={`footer-accordion-content ${openSection === "account" ? "open" : ""}`}>
               {!user ? (
                  <>
                    <Link to="/registration">Create an Account</Link>
                    <Link to="/login">Login to My Account</Link>
                  </>
                ) : (
                  <>
                    <Link to="/update-profile">My Account</Link>
                    <Link to="/orders">My Orders</Link>
                    <Link to="/my-quotes">My Quote History</Link>
                  </>
                )}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          &copy; <span id="year">{new Date().getFullYear()}</span> WorkGear365. All rights reserved.
        </div>
      </footer>

      {/* SUBSCRIBE MODAL (used by top bar + footer) */}
     
      <div
        className={`wg-modal ${isModalOpen ? "is-open" : ""}`}
        id="subscribeModal"
        aria-hidden="true"
        role="dialog"
        aria-modal="true"
        aria-labelledby="subscribeTitle"
      >
        <div className="wg-modal__backdrop" onClick={() => setIsModalOpen(false)}></div>
        <div className="wg-modal__panel" data-state={modalState} role="document">
          <button
            className="wg-modal__close"
            type="button"
            aria-label="Close subscribe form"
            onClick={() => setIsModalOpen(false)}
          >
            &times;
          </button>
          <h2 id="subscribeTitle">Subscribe &amp; Save 10% on Your First Order!</h2>
          <p>
            Subscribe for email updates (and optional SMS). Your 10% discount 
is applied automatically at checkout—no promo code required. Valid 
on your first order only.{" "}
            <strong>Stacks with other promotions</strong> and sale pricing.
          </p>

          <div className="wg-modal__success" id="subscribeSuccess" aria-hidden="true">
            <div className="check">✓</div>
            <h3>You’re subscribed!</h3>
            <p>Your 5% discount will apply automatically on future orders.</p>
          </div>

          <form id="subscribeForm" onSubmit={handleSubmit} noValidate>
            <div>
              <label htmlFor="subEmail">Email address <span aria-hidden="true">*</span></label>
              <input
                id="subEmail"
                name="email"
                type="email"
                autoComplete="email"
                required
                placeholder="you@example.com"
                pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
              />
              <div className="error" id="emailError" aria-live="polite"></div>
            </div>

            <div>
              <label htmlFor="subPhone">Mobile number (optional for SMS)</label>
              <input
                id="subPhone"
                name="phone"
                type="tel"
                autoComplete="tel"
                placeholder="(555) 555-5555"
                pattern="^\(?[0-9]{3}\)?[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$"
              />
            </div>

            <div className="wg-check">
              <input id="consentEmail" name="consent_email" type="checkbox" value="email" required />
              <div className="error" id="emailConsentError" aria-live="polite"></div>
              <span>I agree to receive marketing emails from WorkGear365. Consent is not a condition of purchase.</span>
            </div>

            <div className="wg-check">
              <input id="consentSms" name="consent_sms" value="sms" type="checkbox" />
              <span>
                (Optional) I agree to receive marketing SMS/text messages at the number provided. Message frequency varies. Message/data rates may apply. Reply STOP to unsubscribe, HELP for help.
              </span>
            </div>

            <div className="wg-check">
              <input id="consentPolicies" name="consent_policies" type="checkbox" value="1" required />
              <div className="error" id="policyConsentError" aria-live="polite"></div>
              <span>
                I have read and agree to the <Link to="/privacy">Privacy Policy</Link> and <Link to="/terms">Terms &amp; Conditions</Link>.
              </span>
            </div>

            <button className="wg-modal__submit" type="submit">
              Subscribe
            </button>
            <p className="wg-modal__fineprint">
              For GDPR: you can withdraw consent anytime via unsubscribe links or your account preferences. For TCPA: SMS consent is optional and separate from email.
            </p>
          </form>
        </div>
      </div>

    </>
  );
};

export default Footer;
